import MessageInput from "./components/MessageInput/MessageInput";

export default MessageInput;
